import { GetterTree } from 'vuex';
import { StudentDataState } from './state';
import RootState from '@/store/root_state';
import { AutocompleteOption } from '@/helpers/autocomplete';

const getters: GetterTree<StudentDataState, RootState> = {
  studentFirstName: (state, getters) => {
    return state.personalData?.fullName?.split(' ')[0];
  },
  personalData: (state, getters) => {
    return state.personalData;
  },
  academicFormation: (state, getters) => {
    return state.academicFormation;
  },
  personalDataFinancialSponsor: (state, getters) => {
    return state.personalDataFinancialSponsor;
  },
  identificationDocument: (state, getters) => {
    return state.identificationDocument;
  },
  identificationDocumentFinancialSponsor: (state, getters) => {
    return state.identificationDocumentFinancialSponsor;
  },
  raceOptions: (state, getters) => {
    return state.raceOptions;
  },
  genderOptions: (state, getters) => {
    return state.genderOptions;
  },
  nationalityOptions: (state, getters) => {
    return state.nationalityOptions;
  },
  placeOfBirthOptions: (state, getters) => {
    return (Object.values(state.placeOfBirthOptions) || []).map(
      value => ({ key: value.uf, value: value.name } as AutocompleteOption),
    );
  },
  placeOfBirthOption: (state, getters) => (nameUf: string) => {
    const { uf, name } = state.placeOfBirthOptions[nameUf] || {};
    return {
      key: uf,
      value: name || '',
    } as AutocompleteOption;
  },
  householdIncomeOptions: (state, getters) => {
    return state.householdIncomeOptions;
  },
  statesOptions: (state, getters) => {
    return state.statesOptions;
  },
  issuerOptions: (state, getters) => {
    return state.issuerOptions;
  },
  studentAddress: (state, getters) => {
    return state.addressInfo;
  },
  studentSignupMethod: (state, getters) => {
    return state.signupMethod;
  },
  sponsorAddress: (state, getters) => {
    return state.sponsorAddressInfo;
  },
  issueStateOptions: (state, getters) => {
    return state.issueStateOptions;
  },
  personalDataCpf: (state, getters) => {
    return state.personalData?.cpf;
  },
  countyData: (state, getters) => (key: string) => {
    return state.countys[key];
  },
  countyAutocompleteOption: (state, getters) => (idCounty: string) => {
    const { id, countyFullName } = state.countys[idCounty] || {};
    return {
      key: id,
      value: countyFullName || '',
    } as AutocompleteOption;
  },
  countysAutocompleteOptions: (state, getters) => (uf: string | undefined) => {
    return (Object.values(state.countys) || [])
      .filter(value => value.uf === uf)
      .map(value => ({ key: value.id, value: value.countyFullName } as AutocompleteOption));
  },
  loadingCountysOptions: state => {
    return state.loadingCountysOptions;
  },
};

export default getters;
